import initGroupDeleteModal from '../modules/group-delete-modal';

const initialize = () => {
    initGroupDeleteModal();
};

export default initialize;
